import { AxiosError } from 'axios';
import { toastr } from 'react-redux-toastr';
import branditRails from '../../../../api/brandit_rails';
import { setVendorAction, setVendorsAction, setVendorOptionsAction, setVendorsPaginatedAction, setVendorsStatusAction, setVendorsErrorsAction, clearVendorsErrorsAction } from './vendors.actions';
export const fetchVendor = (id) => async (dispatch) => {
    try {
        dispatch(setVendorsStatusAction('loading'));
        dispatch(clearVendorsErrorsAction());
        const { data } = await branditRails.get(`/vendors/${id}`);
        dispatch(setVendorAction(data));
        dispatch(setVendorsStatusAction('succeeded'));
        return data;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setVendorsErrorsAction({ message: errorMessage }));
        dispatch(setVendorsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const createVendor = (formData) => async (dispatch) => {
    try {
        dispatch(setVendorsStatusAction('loading'));
        dispatch(clearVendorsErrorsAction());
        const { data } = await branditRails.post('/vendors', formData);
        dispatch(setVendorAction(data));
        dispatch(setVendorsStatusAction('succeeded'));
        toastr.success('Success', 'Vendor created successfully!');
        return data;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setVendorsErrorsAction({ message: errorMessage }));
        dispatch(setVendorsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const editVendor = (id, formData) => async (dispatch) => {
    try {
        dispatch(setVendorsStatusAction('loading'));
        dispatch(clearVendorsErrorsAction());
        const { data } = await branditRails.patch(`/vendors/${id}`, formData);
        dispatch(setVendorAction(data));
        dispatch(setVendorsStatusAction('succeeded'));
        toastr.success('Success', 'Vendor updated successfully!');
        return data;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setVendorsErrorsAction({ message: errorMessage }));
        dispatch(setVendorsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const deleteVendor = (id) => async (dispatch) => {
    try {
        dispatch(setVendorsStatusAction('loading'));
        dispatch(clearVendorsErrorsAction());
        await branditRails.delete(`/vendors/${id}`);
        dispatch(setVendorsStatusAction('succeeded'));
        toastr.success('Success', 'Vendor deleted successfully!');
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setVendorsErrorsAction({ message: errorMessage }));
        dispatch(setVendorsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const fetchVendors = (params = {}) => async (dispatch) => {
    try {
        dispatch(setVendorsStatusAction('loading'));
        dispatch(clearVendorsErrorsAction());
        const { data } = await branditRails.get('/vendors', { params });
        dispatch(setVendorsAction(data));
        dispatch(setVendorsStatusAction('succeeded'));
        return data;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setVendorsErrorsAction({ message: errorMessage }));
        dispatch(setVendorsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const fetchVendorsPaginated = (params = {}) => async (dispatch) => {
    try {
        dispatch(setVendorsStatusAction('loading'));
        dispatch(clearVendorsErrorsAction());
        const { data } = await branditRails.get('/vendors', { params });
        dispatch(setVendorsPaginatedAction({ vendors: data.data, meta: data.meta }));
        dispatch(setVendorsStatusAction('succeeded'));
        return data;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setVendorsErrorsAction({ message: errorMessage }));
        dispatch(setVendorsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const fetchVendorOptions = (params = {}) => async (dispatch) => {
    try {
        dispatch(setVendorsStatusAction('loading'));
        dispatch(clearVendorsErrorsAction());
        const { data } = await branditRails.get('/vendor_options', { params });
        dispatch(setVendorOptionsAction(data));
        dispatch(setVendorsStatusAction('succeeded'));
        return data;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setVendorsErrorsAction({ message: errorMessage }));
        dispatch(setVendorsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
